//derive the answered state of a call from its connection timestamps:
//connected -> answered, disconnected without connecting -> not answered, otherwise still ringing
export const getCallAnsweredState = (call) => {
  if (call?.connectedOn) return true;
  if (call?.disconnectedOn) return false;
  return null;
};

//whether calls go through the user's VoIP device: the server dials 3CX only for a user holding both an
//extension and a device, so a device alone must not switch the page to waiting for PBX events
export const hasVoIPDevice = (userData) =>
  Boolean(userData?.extension && userData?.voIPDevice);

//why 3CX did not start a call, as the server names it (ActivityRepository.AddActivityAsync); any other
//failure keeps the generic message, so nothing else is reported as the phone system's fault
const PBX_START_ERRORS = [
  'PBX_DEVICE_NOT_FOUND',
  'PBX_UNREACHABLE',
  'PBX_CALL_NOT_STARTED',
];
export const callStartErrorKey = (error) =>
  PBX_START_ERRORS.includes(error?.payload) ? error.payload : 'CALLSTART_ERROR';

//the tel: link dialled through the branch 3CX prefix; a branch without one dials the bare number
export const toTelHref = (branch, number) =>
  `tel:${branch?.prefix3CX ?? ''}${(number || '').replace('+39', '')}`;
